module.exports = __webpack_public_path__ + "assets/img/default-cover.09e6f297.png";